module.exports = __webpack_public_path__ + "static/img/campo_grafica.2469142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/campo_grafica.jpg
// module id = 1628
// module chunks = 6